// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"1a24ecf3","130":"5d73fd45","241":"9f4077ff","261":"9366eade","284":"e3a3b481","426":"df6f6cc9","453":"8eea49bb","492":"35e171b7","539":"6a4e3e99"}[chunkId] + ".chunk.js";
};